import { Component, inject, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-modale-successo',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div class="modal-card" (click)="activeModal.close()">
      <div class="modal-icon modal-icon-success">
        <i class="bi bi-check-lg"></i>
      </div>
      <div class="modal-title">{{ title || 'Operazione completata' }}</div>
      <div class="modal-subtitle">{{ message || 'La firma del documento è avvenuta correttamente.' }}</div>
    </div>
  `
})
export class ModaleSuccessoComponent implements OnInit {
  activeModal = inject(NgbActiveModal);
  @Input() title = '';
  @Input() message = '';

  ngOnInit() {
    setTimeout(() => {
      this.activeModal.close();
    }, 2000);
  }
}
